var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cryptoUtils, } from '@steempro/dsteem/lib/index-browser';
import EncryptUtils from '@popup/steem/utils/encrypt.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import MkUtils from '@popup/steem/utils/mk.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { AccountValueType } from '@reference-data/account-value-type.enum';
import Config from 'src/config';
import { KeyType, } from 'src/interfaces/keys.interface';
import { KeychainError } from 'src/keychain-error';
import { LocalStorageKeyEnum } from 'src/reference-data/local-storage-key.enum';
import FormatUtils from 'src/utils/format.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
// Valori di default
const DEFAULT_CONFIG = {
    steem_api: "https://api.steemit.com",
    hive_api: "https://api.openhive.network",
    blurt_api: "https://rpc.blurt.blog",
    steem_color: "#90ee90",
    hive_color: "#ffff00",
    blurt_color: "#FF6600"
};
// Variabile globale per la Promise (tipizzata)
let configPromise = null;
/**
 * Funzione principale per ottenere un valore di configurazione.
 * Carica la config da server se non è già stata caricata, altrimenti usa i default.
 * @param key La chiave da cercare (es. 'steem_api', 'hive_color')
 * @returns Il valore della chiave o il default se non trovato
 */
export const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    // Se non c'è una promise in corso, creiamone una
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                // Nota: fetch non supporta nativamente 'timeout' in RequestInit.
                // Usiamo AbortController per il timeout.
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal // Passa il segnale di abort
                });
                clearTimeout(timeoutId);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = yield response.json();
                if (json.ok && json.data) {
                    // console.log('✅ Config loaded from server');
                    return json.data;
                }
            }
            catch (error) {
                console.warn('⚠️ Server unreachable or invalid response, using defaults:', error);
            }
            // Fallback ai default
            return DEFAULT_CONFIG;
        }))();
    }
    // Attendiamo che la promise si risolva
    const config = yield configPromise;
    // Restituiamo il valore richiesto con fallback sicuro
    // Usiamo 'as any' per bypassare il controllo di indice se la chiave non è esplicitamente nel tipo,
    // ma dato che abbiamo [key: string]: string nell'interfaccia, dovrebbe funzionare direttamente.
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
export var AccountErrorMessages;
(function (AccountErrorMessages) {
    AccountErrorMessages["INCORRECT_KEY"] = "popup_accounts_incorrect_key";
    AccountErrorMessages["INCORRECT_USER"] = "popup_accounts_incorrect_user";
    AccountErrorMessages["MISSING_FIELDS"] = "popup_accounts_fill";
    AccountErrorMessages["ALREADY_REGISTERED"] = "popup_accounts_already_registered";
    AccountErrorMessages["PASSWORD_IS_PUBLIC_KEY"] = "popup_account_password_is_public_key";
})(AccountErrorMessages || (AccountErrorMessages = {}));
const getKey = (username, password, chain) => __awaiter(void 0, void 0, void 0, function* () {
    let tAccounts = [];
    if (chain === "hive") {
        tAccounts = yield AccountUtils.getAccountHive(username);
    }
    else if (chain === "blurt") {
        tAccounts = yield AccountUtils.getAccountBlurt(username);
    }
    else {
        tAccounts = yield AccountUtils.getAccountSteem(username);
    }
    if (tAccounts.length === 0) {
        throw new Error(AccountErrorMessages.INCORRECT_USER);
    }
    const activeInfo = tAccounts[0].active;
    const postingInfo = tAccounts[0].posting;
    const memoKey = tAccounts[0].memo_key;
    if (cryptoUtils.isWif(password)) {
        const pubUnknown = KeysUtils.getPublicKeyFromPrivateKeyString(password);
        if (pubUnknown === memoKey) {
            return {
                memo: password,
                memoPubkey: memoKey,
            };
        }
        else if (KeysUtils.getPubkeyWeight(pubUnknown, postingInfo)) {
            return {
                posting: password,
                postingPubkey: pubUnknown,
            };
        }
        else if (KeysUtils.getPubkeyWeight(pubUnknown, activeInfo)) {
            return {
                active: password,
                activePubkey: pubUnknown,
            };
        }
    }
});
const getKeys = (username, password, passwordhive, passwordblurt) => __awaiter(void 0, void 0, void 0, function* () {
    const steemAccounts = yield AccountUtils.getAccountSteem(username);
    const hiveAccounts = yield AccountUtils.getAccountHive(username);
    const blurtAccounts = yield AccountUtils.getAccountBlurt(username);
    if (steemAccounts.length === 0 && hiveAccounts.length === 0 && blurtAccounts.length === 0) {
        throw new Error(AccountErrorMessages.INCORRECT_USER);
    }
    if (steemAccounts.length != 0) {
        const activeInfoSteem = steemAccounts[0].active;
        const postingInfoSteem = steemAccounts[0].posting;
        const memoKeySteem = steemAccounts[0].memo_key;
    }
    if (hiveAccounts.length != 0) {
        const activeInfoHive = hiveAccounts[0].active;
        const postingInfoHive = hiveAccounts[0].posting;
        const memoKeyHive = hiveAccounts[0].memo_key;
    }
    if (blurtAccounts.length != 0) {
        const activeInfoBlurt = blurtAccounts[0].active;
        const postingInfoBlurt = blurtAccounts[0].posting;
        const memoKeyBlurt = blurtAccounts[0].memo_key;
    }
    const keys = KeysUtils.derivateFromMasterPassword(username, password, passwordhive, passwordblurt, steemAccounts[0], hiveAccounts[0], blurtAccounts[0]);
    //  // console.log('keys: ', JSON.stringify(keys));
    if (!keys) {
        throw new Error(AccountErrorMessages.INCORRECT_KEY);
    }
    return keys;
});
const verifyAccount = (username, password, passwordhive, passwordblurt, existingAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    if (password.startsWith('STM')) {
        throw new Error(AccountErrorMessages.PASSWORD_IS_PUBLIC_KEY);
    }
    if (passwordhive.startsWith('STM')) {
        throw new Error(AccountErrorMessages.PASSWORD_IS_PUBLIC_KEY);
    }
    if (passwordblurt.startsWith('BLT')) {
        throw new Error(AccountErrorMessages.PASSWORD_IS_PUBLIC_KEY);
    }
    if (username.length === 0 || password.length === 0) {
        throw new Error(AccountErrorMessages.MISSING_FIELDS);
    }
    if (isAccountNameAlreadyExisting(existingAccounts, username)) {
        throw new Error(AccountErrorMessages.ALREADY_REGISTERED);
    }
    return yield getKeys(username, password, passwordhive, passwordblurt);
});
const saveAccounts = (localAccounts, mk, chain) => __awaiter(void 0, void 0, void 0, function* () {
    const accounts = { list: localAccounts };
    const encyptedAccounts = yield AccountUtils.encryptAccounts(accounts, mk);
    let key;
    if (chain === "hive") {
        key = LocalStorageKeyEnum.ACCOUNTS_HIVE;
    }
    else if (chain === "blurt") {
        key = LocalStorageKeyEnum.ACCOUNTS_BLURT;
    }
    else {
        key = LocalStorageKeyEnum.ACCOUNTS;
    }
    LocalStorageUtils.saveValueInLocalStorage(
    //    LocalStorageKeyEnum.ACCOUNTS,
    key, encyptedAccounts);
});
const getAccountFromLocalStorage = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const mk = yield MkUtils.getMkFromLocalStorage();
    const accounts = yield getAccountsFromLocalStorage(mk);
    const accountshive = yield getAccountsFromLocalStorage(mk, "hive");
    const accountsblurt = yield getAccountsFromLocalStorage(mk, "blurt");
    if (accounts.some(acc => acc.name === username)) {
        return accounts.find((acc) => acc.name === username);
    }
    if (accountshive.some(acc => acc.name === username)) {
        return accountshive.find((acc) => acc.name === username);
    }
    if (accountsblurt.some(acc => acc.name === username)) {
        return accountsblurt.find((acc) => acc.name === username);
    }
    return undefined;
});
const getAccountsFromLocalStorage = (mk, chain) => __awaiter(void 0, void 0, void 0, function* () {
    let key;
    if (chain === "hive") {
        key = LocalStorageKeyEnum.ACCOUNTS_HIVE;
    }
    else if (chain === "blurt") {
        key = LocalStorageKeyEnum.ACCOUNTS_BLURT;
    }
    else {
        key = LocalStorageKeyEnum.ACCOUNTS;
    }
    const encryptedAccounts = yield LocalStorageUtils.getValueFromLocalStorage(key);
    const accounts = EncryptUtils.decryptToJson(encryptedAccounts, mk);
    return ((accounts === null || accounts === void 0 ? void 0 : accounts.list) || []).filter((e) => e.name.length);
});
const isAccountNameAlreadyExisting = (existingAccounts, accountName) => {
    if (!existingAccounts || existingAccounts.length === 0) {
        return false;
    }
    return existingAccounts.some((account) => account.name === accountName);
};
/* istanbul ignore next */
const encryptAccounts = (accounts, mk) => __awaiter(void 0, void 0, void 0, function* () {
    //  return EncryptUtils.encryptJson(accounts, mk);
    return EncryptUtils.encryptJson(accounts);
});
const hasStoredAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
    return ((yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACCOUNTS)) !== undefined);
});
const addAuthorizedKey = (activeAccount, authorizedAccountName, existingAccounts, mk, keyType) => __awaiter(void 0, void 0, void 0, function* () {
    let authorizedAccount = existingAccounts.find((account) => account.name === authorizedAccountName);
    let localActiveAccount = existingAccounts.find((account) => account.name === activeAccount.name);
    if (!authorizedAccount || !localActiveAccount)
        return; // check error
    localActiveAccount.keys[keyType.toLowerCase()] =
        authorizedAccount.keys[keyType.toLowerCase()];
    localActiveAccount.keys[`${keyType.toLowerCase()}Pubkey`] = `@${authorizedAccountName}`;
    return yield AccountUtils.saveAccounts(existingAccounts, mk);
});
const addAuthorizedAccount = (username, authorizedAccount, existingAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    let localAuthorizedAccount;
    if (username === '' || authorizedAccount === '') {
        throw new KeychainError('popup_accounts_fill', []);
    }
    if (!existingAccounts
        .map((localAccount) => localAccount.name)
        .includes(authorizedAccount)) {
        throw new KeychainError('popup_no_auth_account', [authorizedAccount]);
    }
    else {
        localAuthorizedAccount = existingAccounts.find((localAccount) => localAccount.name === authorizedAccount);
    }
    if (existingAccounts
        .map((localAccount) => localAccount.name)
        .includes(username)) {
        throw new KeychainError('popup_accounts_already_registered', []);
    }
    const hiveAccounts = yield AccountUtils.getAccount(username);
    if (!hiveAccounts || hiveAccounts.length === 0) {
        throw new KeychainError('popup_accounts_incorrect_user', []);
    }
    let hiveAccount = hiveAccounts[0];
    const activeKeyInfo = hiveAccount.active;
    const postingKeyInfo = hiveAccount.posting;
    let keys = {};
    const activeAuth = activeKeyInfo.account_auths.find((accountAuth) => accountAuth[0] === authorizedAccount);
    const postingAuth = postingKeyInfo.account_auths.find((accountAuth) => accountAuth[0] === authorizedAccount);
    if (!activeAuth && !postingAuth) {
        throw new KeychainError('popup_accounts_no_auth', [
            authorizedAccount,
            username,
        ]);
    }
    if (activeAuth) {
        keys.active = localAuthorizedAccount.keys.active;
        keys.activePubkey = `@${authorizedAccount}`;
    }
    if (postingAuth) {
        keys.posting = localAuthorizedAccount.keys.posting;
        keys.postingPubkey = `@${authorizedAccount}`;
    }
    return keys;
});
const addKey = (activeAccount, accounts, privateKey, keyType, mk) => __awaiter(void 0, void 0, void 0, function* () {
    if (privateKey.length === 0 || privateKey.trim().length === 0) {
        throw new Error(AccountErrorMessages.MISSING_FIELDS);
    }
    if (privateKey.startsWith('STM')) {
        throw new Error(AccountErrorMessages.PASSWORD_IS_PUBLIC_KEY);
    }
    const keys = yield AccountUtils.getKey(activeAccount.name, privateKey);
    Logger.info(`keys ${keys}`);
    let account = accounts.find((account) => account.name === activeAccount.name);
    if (keys && account) {
        switch (keyType) {
            case KeyType.ACTIVE:
                if (!keys.active) {
                    throw new Error('popup_html_wrong_key_active');
                }
                account.keys.active = keys.active;
                account.keys.activePubkey = keys.activePubkey;
                break;
            case KeyType.POSTING:
                if (!keys.posting) {
                    throw new Error('popup_html_wrong_key_posting');
                }
                account.keys.posting = keys.posting;
                account.keys.postingPubkey = keys.postingPubkey;
                break;
            case KeyType.MEMO:
                if (!keys.memo) {
                    throw new Error('popup_html_wrong_key_memo');
                }
                account.keys.memo = keys.memo;
                account.keys.memoPubkey = keys.memoPubkey;
                break;
        }
        AccountUtils.saveAccounts(accounts, mk);
        return accounts;
    }
});
const deleteKey = (keyType, accounts, activeAccount, mk) => {
    const account = accounts.find((account) => account.name === activeAccount.name);
    if (KeysUtils.keysCount(account === null || account === void 0 ? void 0 : account.keys) > 2) {
        switch (keyType) {
            case KeyType.ACTIVE:
                account === null || account === void 0 ? true : delete account.keys.active;
                account === null || account === void 0 ? true : delete account.keys.activePubkey;
                break;
            case KeyType.POSTING:
                account === null || account === void 0 ? true : delete account.keys.posting;
                account === null || account === void 0 ? true : delete account.keys.postingPubkey;
                break;
            case KeyType.MEMO:
                account === null || account === void 0 ? true : delete account.keys.memo;
                account === null || account === void 0 ? true : delete account.keys.memoPubkey;
                break;
        }
        AccountUtils.saveAccounts(accounts, mk);
        return accounts;
    }
    else {
        Logger.error('Cannot delete the last key');
        return accounts;
    }
};
const deleteAccount = (accountName, accounts) => {
    return accounts.filter((account) => account.name !== accountName);
};
const isAccountListIdentical = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
};
/* istanbul ignore next */
const downloadAccounts = (acc, mk) => __awaiter(void 0, void 0, void 0, function* () {
    const accounts = { list: acc };
    var data = new Blob([yield AccountUtils.encryptAccounts(accounts, mk)], {
        type: 'text/plain',
    });
    var url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'accounts.kc';
    a.click();
});
const getAccountValue = ({ sbd_balance, balance, vesting_shares, savings_balance, savings_sbd_balance, name, }, prices, props, 
// tokensBalance: TokenBalance[],
// tokensMarket: TokenMarket[],
accountValueType, 
// tokens: Token[],
hiveMarketLockedOpenOrdersValues) => {
    var _a, _b;
    if (accountValueType === AccountValueType.HIDDEN)
        return '⁎ ⁎ ⁎';
    if (!((_a = prices.steem_dollars) === null || _a === void 0 ? void 0 : _a.usd) || !((_b = prices.steem) === null || _b === void 0 ? void 0 : _b.usd))
        return 0;
    // const userLayerTwoPortfolio = PortfolioUtils.generateUserLayerTwoPortolio(
    //   {
    //     username: name,
    //     tokensBalance: tokensBalance,
    //   },
    //   prices,
    //   tokensMarket,
    //   tokens,
    //   hiddenTokensList,
    // );
    // const layerTwoTokensTotalValue = userLayerTwoPortfolio.reduce(
    //   (acc, curr) => acc + curr.usdValue,
    //   0,
    // );
    const totalLockedValueInHiveMarket = hiveMarketLockedOpenOrdersValues.sbd * prices.steem_dollars.usd +
        hiveMarketLockedOpenOrdersValues.steem * prices.steem.usd;
    const dollarValue = (parseFloat(sbd_balance) +
        parseFloat(savings_sbd_balance)) *
        prices.steem_dollars.usd +
        (FormatUtils.toSP(vesting_shares, props) +
            parseFloat(balance) +
            parseFloat(savings_balance)) *
            prices.steem.usd +
        totalLockedValueInHiveMarket;
    const value = accountValueType === AccountValueType.DOLLARS
        ? dollarValue
        : dollarValue / prices.steem.usd;
    return FormatUtils.withCommas(value.toString());
};
/* istanbul ignore next */
const getPublicMemo = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const extendedAccounts = yield AccountUtils.getAccount(username);
    return extendedAccounts[0].memo_key;
});
const getPowerDown = (account, globalProperties) => {
    const totalSteem = Number(globalProperties.total_vesting_fund_steem.toString().split(' ')[0]);
    const totalVests = Number(globalProperties.total_vesting_shares.toString().split(' ')[0]);
    const withdrawn = (((Number(account.withdrawn) / totalVests) * totalSteem) /
        1000000).toFixed(0);
    const total_withdrawing = (((Number(account.to_withdraw) / totalVests) * totalSteem) /
        1000000).toFixed(0);
    const next_vesting_withdrawal = account.next_vesting_withdrawal;
    return [withdrawn, total_withdrawing, next_vesting_withdrawal];
};
const doesAccountExist = (username) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield AccountUtils.getAccount(username)).length > 0;
});
/* istanbul ignore next */
const getExtendedAccount = (username) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield AccountUtils.getExtendedAccounts([username]))[0];
});
const getExtendedAccounts = (usernames) => __awaiter(void 0, void 0, void 0, function* () {
    return yield SteemTxUtils.getData('condenser_api.get_accounts', [usernames]);
});
const getAccount = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoints = [
        yield getDefVal('steem_api'),
        yield getDefVal('hive_api'),
        yield getDefVal('blurt_api')
        //    'https://api.openhive.network',
        //    'https://rpc.blurt.blog'
    ];
    // console.log('endpoints: ', endpoints);
    const requestBody = {
        jsonrpc: '2.0',
        method: 'condenser_api.get_accounts',
        params: [[username]],
        id: 1
    };
    for (const url of endpoints) {
        try {
            const response = yield fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                continue;
            }
            const json = yield response.json();
            if (json.result && json.result.length > 0) {
                return json.result;
            }
        }
        catch (err) {
            console.warn(`Errore di rete su ${url}:`, err);
        }
    }
    return [];
});
const getAccountSteem = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoints = [
        yield getDefVal('steem_api'),
    ];
    // console.log('endpoints: ', endpoints);
    const requestBody = {
        jsonrpc: '2.0',
        method: 'condenser_api.get_accounts',
        params: [[username]],
        id: 1
    };
    for (const url of endpoints) {
        try {
            const response = yield fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                continue;
            }
            const json = yield response.json();
            if (json.result && json.result.length > 0) {
                return json.result;
            }
        }
        catch (err) {
            console.warn(`Errore di rete su ${url}:`, err);
        }
    }
    return [];
});
const getAccountHive = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoints = [
        yield getDefVal('hive_api'),
    ];
    // console.log('endpoints: ', endpoints);
    const requestBody = {
        jsonrpc: '2.0',
        method: 'condenser_api.get_accounts',
        params: [[username]],
        id: 1
    };
    for (const url of endpoints) {
        try {
            const response = yield fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                continue;
            }
            const json = yield response.json();
            if (json.result && json.result.length > 0) {
                return json.result;
            }
        }
        catch (err) {
            console.warn(`Errore di rete su ${url}:`, err);
        }
    }
    return [];
});
const getAccountBlurt = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoints = [
        yield getDefVal('blurt_api'),
    ];
    // console.log('endpoints: ', endpoints);
    const requestBody = {
        jsonrpc: '2.0',
        method: 'condenser_api.get_accounts',
        params: [[username]],
        id: 1
    };
    for (const url of endpoints) {
        try {
            const response = yield fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                continue;
            }
            const json = yield response.json();
            if (json.result && json.result.length > 0) {
                return json.result;
            }
        }
        catch (err) {
            console.warn(`Errore di rete su ${url}:`, err);
        }
    }
    return [];
});
const getTime = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/tbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(5));
        if (isNaN(balance)) {
            return 0.0000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.0000; // Fallback in caso di errore
    }
});
const getHive = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/hivebalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getHbd = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/hbdbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getHp = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/hpbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getSteem = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/steembalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getSbd = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/sbdbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getSp = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/spbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getBlurt = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/blurtbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getBp = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let balance = 0.0000; // Valore di default
    const url = `https://timeapp.foundation/bpbalance.php?name=${encodeURIComponent(username)}`;
    try {
        const response = yield fetch(url);
        if (!response.ok) {
            return 0.0000;
        }
        const data = yield response.text();
        const bala = parseFloat(data);
        balance = parseFloat(bala.toFixed(3));
        if (isNaN(balance)) {
            return 0.000; // Fallback in caso di NaN
        }
        return balance;
    }
    catch (error) {
        return 0.000; // Fallback in caso di errore
    }
});
const getRCMana = (username) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const savedChain = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
    const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
    const activeChain = String(saved || 'STEEM').replace(/^"|"$/g, '').trim().toUpperCase();
    if (activeChain === 'TIME' || activeChain === 'BLURT') {
        return {
            percentage: 0,
            rc_manabar: {
                current_mana: 'N/A',
                last_update_time: 0,
            },
            max_rc: 'N/A',
        };
    }
    const endpoints = {
        STEEM: yield getDefVal('steem_api'),
        HIVE: yield getDefVal('hive_api')
    };
    // console.log('endpoints: ', endpoints);
    const url = endpoints[activeChain] || endpoints.STEEM;
    const requestBody = {
        jsonrpc: '2.0',
        method: 'rc_api.find_rc_accounts',
        params: { accounts: [username] },
        id: 1,
    };
    try {
        const response = yield fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });
        if (!response.ok)
            throw new Error(`HTTP ${response.status}`);
        const data = yield response.json();
        if (!((_b = (_a = data.result) === null || _a === void 0 ? void 0 : _a.rc_accounts) === null || _b === void 0 ? void 0 : _b[0])) {
            throw new Error('No RC account found');
        }
        const account = data.result.rc_accounts[0];
        const manabar = account.rc_manabar;
        const max_mana = Number(account.max_rc);
        const delta = Date.now() / 1000 - manabar.last_update_time;
        let current_mana = Number(manabar.current_mana) + (delta * max_mana) / 432000;
        let percentage = Number(((current_mana / max_mana) * 100).toFixed(2));
        if (!isFinite(percentage) || percentage < 0)
            percentage = 0;
        if (percentage > 100)
            percentage = 100;
        return Object.assign({ percentage }, account);
    }
    catch (error) {
        console.error('[getRCMana] Error:', error);
        return {
            percentage: 0,
            rc_manabar: {
                current_mana: 'N/A',
                last_update_time: 0,
            },
            max_rc: 'N/A',
        };
    }
});
const generateQRCode = (account) => {
    let acc = { name: account.name, keys: {} };
    if (KeysUtils.isExportable(account.keys.active, account.keys.activePubkey)) {
        acc.keys.active = account.keys.active;
        acc.keys.activePubkey = account.keys.activePubkey;
    }
    if (KeysUtils.isExportable(account.keys.posting, account.keys.postingPubkey)) {
        acc.keys.posting = account.keys.posting;
        acc.keys.postingPubkey = account.keys.postingPubkey;
    }
    if (KeysUtils.isExportable(account.keys.memo, account.keys.memoPubkey)) {
        acc.keys.memo = account.keys.memo;
        acc.keys.memoPubkey = account.keys.memoPubkey;
    }
    return JSON.stringify(acc);
};
const claimAccounts = (rc, activeAccount, options) => __awaiter(void 0, void 0, void 0, function* () {
    const freeAccountConfig = Config.claims.freeAccount;
    if (activeAccount.rc.percentage > freeAccountConfig.MIN_RC_PCT &&
        parseFloat(rc.rc_manabar.current_mana) > freeAccountConfig.MIN_RC) {
        Logger.info(`Claiming free account for @${activeAccount.name}`);
        return SteemTxUtils.sendOperation([
            [
                'claim_account',
                {
                    creator: activeAccount.name,
                    extensions: [],
                    fee: '0.000 STEEM',
                },
            ],
        ], activeAccount.keys.active, false, options);
    }
    else
        Logger.info('Not enough RC% to claim account');
});
const updateAccount = (username, active, posting, memo, stringifiedMetadata, key, options) => {
    return SteemTxUtils.sendOperation([
        AccountUtils.getUpdateAccountOperation(username, active, posting, memo, stringifiedMetadata),
    ], key, false, options);
};
const getUpdateAccountOperation = (username, active, posting, memo, stringifiedMetadata) => {
    return [
        'account_update',
        {
            account: username,
            owner: undefined,
            active,
            posting,
            memo_key: memo,
            json_metadata: stringifiedMetadata,
        },
    ];
};
/* istanbul ignore next */
const getUpdateAccountTransaction = (username, active, posting, memo, stringifiedMetadata) => {
    return SteemTxUtils.createTransaction([
        AccountUtils.getUpdateAccountOperation(username, active, posting, memo, stringifiedMetadata),
    ]);
};
const addAccount = (username, keys) => __awaiter(void 0, void 0, void 0, function* () {
    const mk = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
    const localAccounts = yield AccountUtils.getAccountsFromLocalStorage(mk);
    localAccounts.push({ name: username, keys: keys });
    yield AccountUtils.saveAccounts(localAccounts, mk);
});
const addMultipleAccounts = (localAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    const mk = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
    let savedAccounts = yield AccountUtils.getAccountsFromLocalStorage(mk);
    if (!savedAccounts)
        savedAccounts = [];
    const newSavedAccounts = [...savedAccounts, ...localAccounts];
    yield AccountUtils.saveAccounts(newSavedAccounts, mk);
});
const reorderAccounts = (accounts, start, end) => {
    const list = Array.from(accounts);
    const [removed] = list.splice(start, 1);
    list.splice(end, 0, removed);
    return list;
};
const getAccountFromKey = (key) => __awaiter(void 0, void 0, void 0, function* () {
    const pubKey = KeysUtils.getPublicKeyFromPrivateKeyString(key.toString());
    const accountName = (yield KeysUtils.getKeyReferences([pubKey]))[0];
    return AccountUtils.getExtendedAccount(accountName[0]);
});
const AccountUtils = {
    verifyAccount,
    getAccountsFromLocalStorage,
    getAccountFromLocalStorage,
    saveAccounts,
    hasStoredAccounts,
    addAuthorizedAccount,
    addKey,
    addMultipleAccounts,
    deleteKey,
    isAccountListIdentical,
    deleteAccount,
    downloadAccounts,
    getKey,
    getKeys,
    getAccountValue,
    getPublicMemo,
    getPowerDown,
    doesAccountExist,
    getExtendedAccount,
    getExtendedAccounts,
    AccountErrorMessages,
    isAccountNameAlreadyExisting,
    getRCMana,
    getAccount,
    getAccountSteem,
    getAccountHive,
    getAccountBlurt,
    generateQRCode,
    encryptAccounts,
    claimAccounts,
    updateAccount,
    getUpdateAccountOperation,
    getUpdateAccountTransaction,
    addAccount,
    reorderAccounts,
    addAuthorizedKey,
    getAccountFromKey,
    getTime,
    getSteem,
    getSbd,
    getSp,
    getHive,
    getHbd,
    getHp,
    getBlurt,
    getBp,
};
export const BackgroundAccountUtils = {
    getAccountsFromLocalStorage,
};
export default AccountUtils;
